/**
 * Client-side retailer resolution for watchlist grouping.
 * Prefer explicit retailer/merchant over product brand.
 */
export function resolveWatchlistRetailer(item = {}) {
  const retailer = String(item.retailer || '').trim();
  const merchant = String(item.merchantName || '').trim();
  const brand = String(item.productBrand || item.brand || '').trim();

  if (retailer && (!brand || retailer.toLowerCase() !== brand.toLowerCase())) {
    return retailer;
  }
  if (merchant && (!brand || merchant.toLowerCase() !== brand.toLowerCase())) {
    return merchant;
  }
  return retailer || merchant || brand || 'Other';
}

export function resolveProductRetailerForWishlist(product = {}) {
  const retailer = String(product.retailer || '').trim();
  const merchant = String(product.merchantName || '').trim();
  const brand = String(product.brand || '').trim();

  if (retailer && (!brand || retailer.toLowerCase() !== brand.toLowerCase())) {
    return retailer;
  }
  if (merchant && (!brand || merchant.toLowerCase() !== brand.toLowerCase())) {
    return merchant;
  }
  return retailer || merchant || brand || 'Unknown';
}
